import { render, staticRenderFns } from "./routerCell.vue?vue&type=template&id=74de9bb8&scoped=true"
import script from "./routerCell.vue?vue&type=script&lang=js"
export * from "./routerCell.vue?vue&type=script&lang=js"
import style0 from "./routerCell.vue?vue&type=style&index=0&id=74de9bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74de9bb8",
  null
  
)

export default component.exports